import styled from 'styled-components';

export interface ContainerProps {
  fullHeight?: boolean;
  absolute?: boolean;
  align?: 'top' | 'center' | 'bottom';
  maxWidth?: number;
}

const alignMap: { [ key in Exclude<ContainerProps['align'], undefined> ]: string; } = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

const Container = styled.div<ContainerProps>`
  position: ${({ absolute }) => absolute && 'absolute'};
  flex-direction: column;
  left: ${({ absolute }) => absolute && 0};
  right: ${({ absolute }) => absolute && 0};
  display: ${({ align }) => align && 'flex'};
  justify-content: ${({ align }) => align && alignMap[align]};
  width: 100%;
  max-width: ${({ maxWidth, theme }) => maxWidth ? maxWidth : theme.maxWidth}px;
  height: ${({ fullHeight }) => fullHeight && '100vh'};
  box-sizing: border-box;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-left: auto;
  margin-right: auto;
`;

export { Container };
